import React from 'react';
import withIcon from '../utilities/withIcon';

const IconChartPie = () => {
  return (
    <g>
      <path d="m14.8538 11.9135a7.84 7.84 0 0 0 0-7.827c-.0059-.0115-.0054-.0244-.012-.0357-.0082-.0142-.0223-.0221-.0313-.0355a7.9482 7.9482 0 0 0 -2.8258-2.8258c-.0134-.009-.0212-.023-.0355-.0312-.0113-.0065-.0241-.0061-.0356-.012a7.8988 7.8988 0 1 0 2.9037 10.8273c.0065-.01.0184-.0138.0245-.0243s.0062-.0243.012-.0358zm-6.1538-10.3742a6.44 6.44 0 0 1 1.9222.5181l-1.9222 3.3296zm5.8 6.4607a6.4553 6.4553 0 0 1 -.5573 2.6224l-4.5427-2.6224 4.5426-2.6224a6.4553 6.4553 0 0 1 .5574 2.6224zm-1.2618-3.8323-3.3261 1.92 1.92-3.3261a6.5459 6.5459 0 0 1 1.4061 1.4061zm-5.2382 10.3323a6.4992 6.4992 0 0 1 -.7-12.9607v6.4607c0 .0147.0075.0269.0084.0414a.6676.6676 0 0 0 .0123.0909.7319.7319 0 0 0 .06.178c.0064.0127.006.0269.0132.0393.0061.01.018.0143.0245.0244a.6711.6711 0 0 0 .0585.0792.681.681 0 0 0 .11.0971.6594.6594 0 0 0 .0637.0562l5.5878 3.2258a6.4887 6.4887 0 0 1 -5.2384 2.6677z" />
    </g>
  );
};

export default withIcon(IconChartPie);
